import { useState } from "react";
import { Minus, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const Stepper = ({ value, min, max, onChange, testId }) => (
  <div className="flex items-center gap-3">
    <Button type="button" size="icon" variant="secondary" data-testid={`${testId}-minus`} onClick={() => onChange(Math.max(min, value - 1))}><Minus className="w-4 h-4" /></Button>
    <span className="w-8 text-center text-xl font-bold" data-testid={`${testId}-value`}>{value}</span>
    <Button type="button" size="icon" variant="secondary" data-testid={`${testId}-plus`} onClick={() => onChange(Math.min(max, value + 1))}><Plus className="w-4 h-4" /></Button>
  </div>
);

export const QuickSetupDialog = ({ open, onOpenChange, onCreate, t, busy }) => {
  const [v, setV] = useState({ title: "", language: "en", customers: 3, questions: 2 });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="quick-setup-dialog">
        <DialogHeader>
          <DialogTitle>{t("quick_setup")}</DialogTitle>
          <DialogDescription>{t("customer_hint")}</DialogDescription>
        </DialogHeader>
        <form className="grid gap-5" onSubmit={(e) => { e.preventDefault(); onCreate({ ...v, title: v.title.trim() || t("new_quiz") }); }}>
          <div className="grid gap-2">
            <Label>{t("quiz_title")}</Label>
            <Input data-testid="quick-setup-title-input" autoFocus value={v.title} onChange={(e) => setV({ ...v, title: e.target.value })} />
          </div>
          <div className="grid gap-2">
            <Label>{t("language")}</Label>
            <div className="flex gap-2">
              {["en", "fi"].map((l) => (
                <Button key={l} type="button" data-testid={`quick-setup-lang-${l}`} variant={v.language === l ? "default" : "secondary"} onClick={() => setV({ ...v, language: l })}>
                  {l === "en" ? t("english") : t("finnish")}
                </Button>
              ))}
            </div>
          </div>
          <div className="flex items-center justify-between"><Label>{t("num_customers")}</Label>
            <Stepper testId="quick-setup-customers" value={v.customers} min={1} max={12} onChange={(n) => setV({ ...v, customers: n })} /></div>
          <div className="flex items-center justify-between"><Label>{t("q_per_customer")}</Label>
            <Stepper testId="quick-setup-questions" value={v.questions} min={1} max={10} onChange={(n) => setV({ ...v, questions: n })} /></div>
          <Button type="submit" data-testid="quiz-builder-create-button" className="font-bold h-11" disabled={busy}>{t("create")}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
